import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

export const ACC_AUTHORIZED =
  FORM_FIELDS.PROCUREMENT_DETAILS.AGREEMENT.ACC_AUTHORIZED;

export const ACC_WITNESS =
  FORM_FIELDS.PROCUREMENT_DETAILS.AGREEMENT.ACC_WITNESS;

export const VENDOR_AUTHORIZED =
  FORM_FIELDS.PROCUREMENT_DETAILS.AGREEMENT.VENDOR_AUTHORIZED;

export const VENDOR_WITNESS =
  FORM_FIELDS.PROCUREMENT_DETAILS.AGREEMENT.VENDOR_WITNESS;

export const contractAgreementValidation = yup.object().shape({
  [ACC_AUTHORIZED.PERSON_EMAIL]: yup
    .string()
    .email("Please enter valid acc authorized person's email")
    .required("acc authorized person email is required"),
  accWitness: yup.array().of(
    yup.object().shape({
      [ACC_WITNESS.EMAIL]: yup
        .string()
        .email("Please enter valid acc witness person's email"),
    }),
  ),

  vendorWitness: yup.array().of(
    yup.object().shape({
      [VENDOR_WITNESS.EMAIL]: yup
        .string()
        .email("Please enter valid vendor witness person's email"),
    }),
  ),

  [VENDOR_AUTHORIZED.PERSON_EMAIL]: yup
    .string()
    .email("Please enter valid vendor authorized person's email"),
});
